module.exports = __webpack_public_path__ + "img/s1_t1_30.3218a2ef.jpeg";